(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/bigstat/assets/javascripts/bigstat-modal.js') >= 0) return;  svs.modules.push('/components/sportinfo/bigstat/assets/javascripts/bigstat-modal.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$components$lbUi$ = svs.components.lbUi.modal,
  Modal = _svs$components$lbUi$.Modal,
  ModalPortal = _svs$components$lbUi$.ModalPortal;
const BigStat = svs.components.sportinfo.bigstat.BigStat;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const BigStatModal = _ref => {
  let isOpen = _ref.isOpen,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    elSelector = _ref.elSelector,
    BigStatProps = _ref.BigStatProps,
    Bottom = _ref.Bottom;
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    el = _useState2[0],
    setEl = _useState2[1];
  useEffect(() => {
    var _document$querySelect, _document$querySelect2, _document$querySelect3, _document$querySelect4;
    if (!el) {
      return;
    }
    const stickyBottom = ((_document$querySelect = document.querySelector('.sticky-bottom')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.offsetHeight) || 0;
    const headerTitle = ((_document$querySelect2 = document.querySelector('.header-title')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.offsetHeight) || 0;
    const balanceBar = ((_document$querySelect3 = document.querySelector('.balance-bar-legal')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.offsetHeight) || 0;
    const topBar = ((_document$querySelect4 = document.querySelector('.balance-bar-libuttons')) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.offsetHeight) || 0;
    const betslipOffset = BigStatProps.Betslip ? 44 : 0;
    const pixels = headerTitle + balanceBar + topBar + stickyBottom - betslipOffset;
    el.style.setProperty('min-height', "calc(100vh - ".concat(pixels, "px)"));
    const nav = document.querySelector(elSelector);
    const navPadding = nav === null || nav === void 0 ? void 0 : nav.style.paddingBottom;
    if (nav && isOpen) {
      nav.style.paddingBottom = '0px';
    }
    return () => {
      if (nav) {
        nav.style.paddingBottom = navPadding;
      }
    };
  }, [isOpen, el]);
  return React.createElement(ModalPortal, null, React.createElement(Modal, {
    className: className,
    isOpen: isOpen
  }, React.createElement("div", {
    className: "bigstat-modal-handler",
    ref: node => {
      if (node) {
        setEl(node);
      }
    }
  }, React.createElement(BigStat, BigStatProps)), svs.core.detect.formfactor.mobile() && React.createElement(Bottom, null)));
};
setGlobal('svs.components.sportinfo.bigstat.BigStatModal', BigStatModal);

 })(window);